<template>
  <div class="BaseArticlePage">
    <BaseCommonPage>
      <component v-bind:is="component" v-bind="{ categoryUrl: categoryUrl }" />
    </BaseCommonPage>
  </div>
</template>

<script>
import BaseCommonPage from "./BaseCommonPage";
import Category from "./Category";
import Top from "./Top";

export default {
  name: "BaseCategoryPage",
  props: {
    categoryUrl: String,
  },
  components: {
    BaseCommonPage,
    Category,
  },
  computed: {
    component: function () {
      const category = this.$store.state.categories.find((category) => {
        return this.categoryUrl == category.title;
      });

      if (category) {
        return Category;
      }
      return Top;
    },
  },
};
</script>

<style>
</style>
